module.exports = __webpack_public_path__ + "static/media/powered-wolly-logo-negro.e49dc490.png";